import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../../assets/style/Login.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const Login = ({ setUpdateTheme }) => {
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [employeeForm, setEmployeeFrom] = useState(false);
  const location = useLocation();

  const SignupSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email address is required."),
    password: Yup.string().required("Please enter your password."),
  });

  const EmployeeSignupSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email address is required."),
    password: Yup.string().required("Please enter your password."),
  });

  return (
    <div className="login-page">
      <div className="header-wrapper">
        <div className="header-section">
          <div className="header-overlay"></div>
          <div className="hero-text">
            <h1>Welcome!</h1>
          </div>
        </div>
      </div>

      <div className="signup-form">
        <h2>{isForgotPassword ? "Reset your password" : "Login"}</h2>

        <div className="social-buttons">
          <button className="social-button">f</button>
          <button className="social-button">
            <svg viewBox="0 0 24 24" width="18" height="18">
              <path
                d="M12 2a10 10 0 0 1 10 10c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 3c-3.87 0-7 3.13-7 7 0 3.87 3.13 7 7 7 3.87 0 7-3.13 7-7 0-3.87-3.13-7-7-7zm0 2c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
                fill="currentColor"
              />
            </svg>
          </button>
          <button className="social-button">G</button>
        </div>

        <div className="divider">or</div>

        {error && (
          <div className="usa-alert usa-alert--error" role="alert">
            <div className="usa-alert__body">
              <p className="usa-alert__text">{error}</p>
            </div>
          </div>
        )}

        {successMsg && (
          <div className="usa-alert usa-alert--success" role="alert">
            <div className="usa-alert__body">
              <p className="usa-alert__text">{successMsg}</p>
            </div>
          </div>
        )}

        <Formik
          initialValues={
            employeeForm
              ? { cpc_db: "", email: "", password: "" }
              : { email: "", password: "" }
          }
          validationSchema={employeeForm ? EmployeeSignupSchema : SignupSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            axios
              .post(
                `http://103.251.215.17:8090/api${location.pathname}`,
                values
              )
              .then((response) => {
                // Save to localStorage
                const data = response.data.data;
                localStorage.setItem("token", data.token);
                localStorage.setItem("all_branches", data.all_branches);
                localStorage.setItem("theme_settingtest", data.theme_setting);
                localStorage.setItem("financial_year", data.financial_year);
                localStorage.setItem("user_type", data.user_type);
                localStorage.setItem("employee_type", data.employee_type);
                localStorage.setItem("cpc_db", data.cpc_db);
                localStorage.setItem("username", data.username);
                localStorage.setItem("cpc_allowed", data.cpc_allowed);
                localStorage.setItem("customer_allowed", data.customer_allowed);
                localStorage.setItem("masters_allowed", data.masters_allowed);
                localStorage.setItem("emp_allowed", data.emp_allowed);
                localStorage.setItem("help_allowed", data.help_allowed);
                localStorage.setItem("settings_allowed", data.settings_allowed);
                localStorage.setItem("roles_allowed", data.roles_allowed);
                sessionStorage.setItem("isLoggedIn", "true");
                localStorage.setItem("isLoggedIn", "true");
                // Show success
                toast.success("Login successful!");
                setError("");
                setSubmitting(false);
                resetForm();
                setTimeout(() => {
                  // navigate(
                  //     "/dashboard"
                  // );

                  window.location.replace("/");
                }, 1000);
              })
              .catch((error) => {
                setSubmitting(false);
                if (error.response?.status === 401) {
                  toast.error(error.response.data.message);
                } else {
                  toast.error("Something went wrong. Please try again.");
                }
              });
          }}
        >
          {({ isSubmitting, resetForm }) => (
            <Form>
              <div className="form-group">
                <label htmlFor={isForgotPassword ? "forgotEmail" : "email"}>
                  Email
                </label>
                <Field
                  type="email"
                  name={isForgotPassword ? "forgotEmail" : "email"}
                  placeholder="Email"
                  required
                />
                <ErrorMessage
                  name={isForgotPassword ? "forgotEmail" : "email"}
                  component="div"
                  className="error-message"
                />
              </div>

              {!isForgotPassword && (
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <Field
                    type="password"
                    name="password"
                    placeholder="••••••••"
                    required
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error-message"
                  />
                </div>
              )}

              <div className="checkbox-container">
                <span
                  className="forgot-link"
                  onClick={() => {
                    resetForm();
                    setError("");
                    setSuccessMsg("");
                    setIsForgotPassword(!isForgotPassword);
                  }}
                >
                  {isForgotPassword ? "Back to Login" : "Forgot Password?"}
                </span>
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isForgotPassword ? "RESET PASSWORD" : "SIGN IN"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Login;
// import { useState } from 'react';

// export default function TaxReturnDisplay() {
//   const [taxData, setTaxData] = useState({
//     returnType: "1040",
//     filingStatus: "Electronic",
//     submissionDate: "02/27/2023",
//     submissionTime: "11:10:00 AM",
//     documentId: "20230227123456",
//     taxYear: "2022",
//     firstName: "JOHN",
//     lastName: "DOE",
//     ssn: "***-**-1234",
//     address: "123 MAIN STREET",
//     city: "ANYTOWN",
//     state: "CA",
//     zipCode: "90210",
//     adjustedGrossIncome: "$78,950.00",
//     taxableIncome: "$54,325.00",
//     totalTax: "$6,245.30",
//     federalWithholding: "$7,850.00",
//     refundAmount: "$1,604.70",
//     dependents: 2,
//     claimedCredits: "$2,000.00",
//     qualifyingChildCredit: "$1,500.00",
//     otherIncomeTaxCredits: "$500.00",
//     estimatedTaxPayments: "$1,200.00",
//     vendorName: "TAX PREPARATION SERVICES INC.",
//     vendorId: "TP-987654321",
//     preparerTin: "P12345678",
//     preparationFee: "$299.00",
//     processingFee: "$29.95",
//     totalVendorCompensation: "$328.95",
//     preparerName: "JANE SMITH",
//     preparationDate: "02/15/2023"
//   });

//   return (
//     <div>
//       {/* Header Section */}
//       <div>
//         <div>
//           <div>
//             BASIC TAX RETURN
//           </div>
//           <div>
//             <div>Filing Method: {taxData.filingStatus}</div>
//             <div>Submitted on: {taxData.submissionDate}</div>
//             <div>Time: {taxData.submissionTime}</div>
//           </div>
//         </div>
//         <div>
//           <div>
//             <span>ID: </span>{taxData.documentId}
//           </div>
//         </div>
//       </div>

//       {/* Tax Year and Form Section */}
//       <div>
//         <div>
//           <div>
//             <div>Tax Year</div>
//             <div>{taxData.taxYear}</div>
//           </div>
//           <div>
//             <div>Form Type</div>
//             <div>{taxData.returnType}</div>
//           </div>
//         </div>
//       </div>

//       {/* Part A - Taxpayer Information */}
//       <div>
//         <div>PART A - TAXPAYER INFORMATION</div>
//         <div>
//           <div>
//             <div>First Name</div>
//             <div>{taxData.firstName}</div>
//           </div>
//           <div>
//             <div>Last Name</div>
//             <div>{taxData.lastName}</div>
//           </div>
//         </div>
//         <div>
//           <div>SSN</div>
//           <div>{taxData.ssn}</div>
//         </div>
//         <div>
//           <div>Address</div>
//           <div>{taxData.address}</div>
//         </div>
//         <div>
//           <div>
//             <div>City</div>
//             <div>{taxData.city}</div>
//           </div>
//           <div>
//             <div>State</div>
//             <div>{taxData.state}</div>
//           </div>
//           <div>
//             <div>Zip Code</div>
//             <div>{taxData.zipCode}</div>
//           </div>
//         </div>
//       </div>

//       {/* Financial Information */}
//       <div>
//         <div>FINANCIAL SUMMARY</div>
//         <div>
//           <div>
//             <div>Adjusted Gross Income</div>
//             <div>{taxData.adjustedGrossIncome}</div>
//           </div>
//           <div>
//             <div>Taxable Income</div>
//             <div>{taxData.taxableIncome}</div>
//           </div>
//         </div>
//         <div>
//           <div>
//             <div>Total Tax</div>
//             <div>{taxData.totalTax}</div>
//           </div>
//           <div>
//             <div>Federal Withholding</div>
//             <div>{taxData.federalWithholding}</div>
//           </div>
//         </div>
//       </div>

//       {/* Part B - Additional Tax Information */}
//       <div>
//         <div>PART B - ADDITIONAL TAX INFORMATION</div>
//         <div>
//           <div>
//             <div>Dependents Claimed</div>
//             <div>{taxData.dependents}</div>
//           </div>
//           <div>
//             <div>Total Credits Claimed</div>
//             <div>{taxData.claimedCredits}</div>
//           </div>
//         </div>
//         <div>
//           <div>
//             <div>Qualifying Child Credit</div>
//             <div>{taxData.qualifyingChildCredit}</div>
//           </div>
//           <div>
//             <div>Other Income Tax Credits</div>
//             <div>{taxData.otherIncomeTaxCredits}</div>
//           </div>
//         </div>
//         <div>
//           <div>Estimated Tax Payments</div>
//           <div>{taxData.estimatedTaxPayments}</div>
//         </div>
//       </div>

//       {/* Refund Information */}
//       <div>
//         <div>REFUND INFORMATION</div>
//         <div>
//           <div>
//             <div>Refund Amount</div>
//             <div>{taxData.refundAmount}</div>
//           </div>
//         </div>
//       </div>

//       {/* Vendor's Compensation */}
//       <div>
//         <div>VENDOR'S COMPENSATION</div>
//         <div>
//           <div>
//             <div>Vendor Name</div>
//             <div>{taxData.vendorName}</div>
//           </div>
//           <div>
//             <div>Vendor ID</div>
//             <div>{taxData.vendorId}</div>
//           </div>
//         </div>
//         <div>
//           <div>
//             <div>Preparer TIN</div>
//             <div>{taxData.preparerTin}</div>
//           </div>
//           <div>
//             <div>Preparer Name</div>
//             <div>{taxData.preparerName}</div>
//           </div>
//         </div>
//         <div>
//           <div>
//             <div>Preparation Fee</div>
//             <div>{taxData.preparationFee}</div>
//           </div>
//           <div>
//             <div>Processing Fee</div>
//             <div>{taxData.processingFee}</div>
//           </div>
//         </div>
//         <div>
//           <div>Total Vendor Compensation</div>
//           <div>{taxData.totalVendorCompensation}</div>
//         </div>
//         <div>
//           <div>Preparation Date</div>
//           <div>{taxData.preparationDate}</div>
//         </div>
//       </div>
//     </div>
//   );
// }
